export default __webpack_public_path__ + "static/media/woodwall.f080da4e.png";